// 대운 전환 계산. 운은 스탯을 바꾸지 않고, 어떤 사건이 나오는지를 정하는 환경이다.
// 전환기 길이는 게임 수치(고서 근거 없음)이다. 입력을 바꾸지 않는 순수 함수다.
import { sipseong } from './hanja.js';
import { GROUPS } from './rules.js';

// 대운이 시작한 해부터 이 기간(년)을 전환기로 본다. 제안값이며 고서의 수치가 아니다.
export const TRANSITION_YEARS = 3;

const TEN_GROUP = { 비견: 0, 겁재: 0, 식신: 1, 상관: 1, 편재: 2, 정재: 2, 편관: 3, 정관: 3, 편인: 4, 정인: 4 };

/** 대운 시작 나이(소수)가 처음으로 적용되는 만 나이. 엔진의 열린 기회 계산(`d.age <= age`)과 같은 기준이다. */
export const transitionAge = (daewoon) => Math.ceil(daewoon.age);

/**
 * 그 나이의 대운 정보.
 * { daewoon, startAge, yearsSince, inTransition, ten, group } — 첫 대운 시작 전이나 자료가 없으면 daewoon 이 null.
 */
export function luckAt(saju, age) {
  const none = { daewoon: null, startAge: null, yearsSince: null, inTransition: false, ten: null, group: null };
  const list = saju?.daewoon?.list;
  const dayStem = saju?.day?.stem;
  if (!Array.isArray(list) || !Number.isInteger(dayStem)) return none;
  let current = null;
  for (const d of list) if (transitionAge(d) <= age) current = d; // 목록은 나이순이다
  if (!current) return none;
  const ten = sipseong(dayStem, current.stem);
  const yearsSince = age - transitionAge(current);
  return {
    daewoon: current, startAge: current.age, yearsSince,
    inTransition: yearsSince >= 0 && yearsSince < TRANSITION_YEARS,
    ten, group: GROUPS[TEN_GROUP[ten]],
  };
}
